export const SCREENING_SECTIONS = [
  {
    id: 'developmental-milestones',
    title: 'Part 1: Developmental Milestones & Social Skills',
    questions: [
      { id: 'gm1', label: 'Can the child hold their head steadily?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'gm2', label: 'Can the child roll over (front to back and back to front)?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'gm3', label: 'Can the child sit without support?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'gm4', label: 'Can the child crawl or move on all fours?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'gm5', label: 'Can the child stand and walk independently?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'gm6', label: 'Can the child climb stairs?', options: ['Yes', 'With Help', 'No', 'Not Sure'] },
      { id: 'gm7', label: 'Can the child jump with both feet?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'fm1', label: 'Does the child reach for and grasp objects?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'fm2', label: 'Can the child transfer objects from one hand to another?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'fm3', label: 'Does the child use a pincer grasp (thumb and forefinger)?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'fm4', label: 'Can the child stack blocks or nest cups?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'fm5', label: 'Does the child scribble or draw?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'fm6', label: 'Can the child use utensils to feed themselves?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'cm1', label: 'Does the child respond to sounds and voices?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'cm2', label: 'What is the child’s level of speech?', options: ['Not yet speaking', 'Single words', 'Small sentences'] },
      { id: 'cm3', label: 'Does the child follow simple instructions?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'cm4', label: 'Can the child combine two or more words?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'cm5', label: 'Is the child’s speech understandable to strangers?', options: ['Yes', 'Partially', 'No'] },
      { id: 'ss1', label: 'Does the child smile or make eye contact?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'ss2', label: 'Does the child show interest in other children?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'ss3', label: 'Can the child play simple games (e.g., peek-a-boo, ball rolling)?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'ss4', label: 'Does the child express emotions appropriately?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'ss5', label: 'How does the child behave when separated from caregivers?', options: ['Easily manages', 'Sometimes difficult', 'Very difficult'] }
    ]
  },
  {
    id: 'medical-history',
    title: 'Part 2: Medical History & Clinical Screening',
    questions: [
      { id: 'vs1', label: 'Does the child respond to visual stimuli?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'vs2', label: 'Can the child follow moving objects?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'vs3', label: 'Are the child’s eyes aligned and moving together?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'vs4', label: 'Is there any abnormality in the eyes?', options: ['No', 'Yes'] },
      { id: 'vs5', label: 'If yes, please describe the eye issue:', type: 'text' },
      { id: 'hs1', label: 'Does the child startle at loud sounds?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'hs2', label: 'Does the child turn towards sounds or voices?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'hs3', label: 'Is there appropriate babbling or vocalisation?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'hs4', label: 'Does the child respond to their name?', options: ['Yes', 'No', 'Not Sure'] },
      { id: 'hs5', label: 'Is there a delay in speech development?', options: ['No', 'Mild', 'Significant', 'Not Sure'] },
      { id: 'mh1', label: 'Is there any history of pregnancy complications?', options: ['Yes', 'No'] },
      { id: 'mh2', label: 'If yes, please describe:', type: 'text' },
      { id: 'mh3', label: 'Is there any history of birth-related issues?', options: ['Yes', 'No'] },
      { id: 'mh4', label: 'If yes, please describe:', type: 'text' },
      { id: 'mh5', label: 'Is there any family history of medical conditions or developmental disorders?', options: ['Yes', 'No'] },
      { id: 'mh6', label: 'If yes, please describe:', type: 'text' },
      { id: 'pc1', label: 'Have you noticed any concerns in your child’s behaviour, skills, or responses?', type: 'textarea' },
      { id: 'pc2', label: 'What is your main concern about your child?', type: 'textarea' }
    ]
  }
];

export const THERAPIST_EVALUATION_SECTIONS = [
  {
    id: 'comprehensive-clinical-evaluation',
    title: 'Comprehensive Clinical Evaluation',
    questions: [
      { id: 'oo1', label: 'Was the child cooperative?', options: ['Yes', 'No', 'Partial'] },
      { id: 'oo2', label: 'Attention level?', options: ['Good', 'Average', 'Poor'] },
      { id: 'kd1', label: 'Motor Skills:', options: ['Normal', 'Needs Support'] },
      { id: 'kd2', label: 'Communication:', options: ['Normal', 'Delayed'] },
      { id: 'kd3', label: 'Social Interaction:', options: ['Good', 'Limited'] },
      { id: 'kd4', label: 'Behavior:', options: ['Normal', 'Concern'] },
      { id: 'dl1', label: 'Independence level?', options: ['Independent', 'Needs Help', 'Dependent'] },
      { id: 'pl1', label: 'Overall Rating:', options: ['Good', 'Moderate', 'Needs Improvement'] },
      { id: 'cn1', label: 'Any issues observed?', type: 'text' },
      { id: 'tn1', label: 'Observations / Comments', type: 'textarea' },
      { id: 'rc1', label: 'Next Step:', options: ['Continue Therapy', 'Further Evaluation', 'Refer Specialist'] }
    ]
  }
];
